module.exports = __webpack_public_path__ + "static/media/laura_cozmanca.92fc0488.png";